import { withFormik } from 'formik'
import _ from 'lodash'
import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../Components/Button'
import Field from '../../../Components/Formik/Field'
import Form from '../../../Components/Formik/Form'
import { ACCOUNT_SETUP_TYPES, STATUS } from '../../../Util/Options'
import { GET_DATA, SET_DATA, validateAccess } from '../../../Util/Util'

function Filter(props) {
  const history = useHistory()

  const onSubmitForm = async () => {
    props.validateForm().then((err) => {
      if (_.isEmpty(err)) {
        props.onFilter(_(props.values).omitBy(_.isEmpty).value())
        SET_DATA('accountSetups.filterData', props.values)
      }
    })
  }

  const onClear = () => {
    props.resetForm({})
    props.onFilter({})
  }

  return (
    <div className="filter-section">
      {validateAccess('add-account-setup') && (
        <Button
          onClick={() => history.push('/app/add-account-setup')}
          variant="primary"
          className="btn-block">
          <i className="flaticon-plus" /> Add Account Setup
        </Button>
      )}
      <Form>
        <div className="form-fields">
          <Field label="Code" name="code" />
        </div>
        <div className="form-fields">
          <Field label="Name" name="name" />
        </div>
        <div className="form-field">
          <Field label="Type" name="type" as="select" options={ACCOUNT_SETUP_TYPES} />
        </div>
        <div className="form-fields">
          <Field label="Staus" name="status" as="select" options={STATUS} />
        </div>
        <div className="form-fields">
          <Button variant="secondary" className="search" onClick={onSubmitForm}>
            <i className="flaticon-search-interface-symbol" />
            Search
          </Button>
          <Button className="btn-block btn-glow search" onClick={onClear}>
            Clear
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default withFormik({
  mapPropsToValues: () => {
    const filterObj = GET_DATA('accountSetups.filterData')

    return {
      code: filterObj?.code || '',
      name: filterObj?.name || '',
      type: filterObj?.type || '',
      status: filterObj?.status || ''
    }
  },
  handleSubmit: () => null
})(Filter)
